import { GlButton, GlIcon, GlTooltipDirective, GlTruncate } from '../../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { n__, s__, sprintf } from '~/locale';
import { getIdFromGraphQLId } from '~/graphql_shared/utils';
import ConfirmActionModal from '../../../../../../../app/assets/javascripts/vue_shared/components/confirm_action_modal.vue?vue3';
import { disconnectMcpServer } from '../../duo_agents_platform/pages/mcp_servers/utils.js?vue3';
import { AI_CATALOG_MCP_SERVERS_SHOW_ROUTE } from '../router/constants';
export default {
    name: 'AiCatalogMcpServerListItem',
    components: {
        GlButton,
        GlIcon,
        GlTruncate,
        ConfirmActionModal
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    props: {
        item: {
            type: Object,
            required: true
        },
        showRoute: {
            type: String,
            required: false,
            default: null
        },
        showConnect: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    emits: [
        'connect',
        'disconnected'
    ],
    data () {
        return {
            showDisconnectModal: false
        };
    },
    computed: {
        itemId () {
            return getIdFromGraphQLId(this.item.id);
        },
        showItemRoute () {
            return {
                name: this.showRoute || AI_CATALOG_MCP_SERVERS_SHOW_ROUTE,
                params: {
                    id: this.itemId
                }
            };
        },
        authTypeLabel () {
            if (this.item.authType === 'OAUTH') {
                return s__('AICatalog|OAuth');
            }
            if (this.item.authType === 'NO_AUTH') {
                return s__('AICatalog|No authentication');
            }
            return this.item.authType;
        },
        isOAuth () {
            return this.item.authType === 'OAUTH';
        },
        isConnected () {
            return Boolean(this.item.currentUserConnected);
        },
        shouldShowAuthButton () {
            return this.showConnect && this.isOAuth;
        },
        showConnectButton () {
            return this.shouldShowAuthButton && !this.isConnected;
        },
        showDisconnectButton () {
            return this.shouldShowAuthButton && this.isConnected;
        },
        agents () {
            return this.item.agents || [];
        },
        agentCount () {
            return this.agents.length;
        },
        agentCountLabel () {
            return n__('AICatalog|%d agent', 'AICatalog|%d agents', this.agentCount);
        },
        agentNamesTooltip () {
            const MAX_NAMES = 5;
            const names = this.agents.map((a)=>a.name);
            const remainder = names.length - MAX_NAMES;
            return names.slice(0, MAX_NAMES).join(', ') + (remainder > 0 ? `, +${n__('AICatalog|%d more', 'AICatalog|%d more', remainder).replace('%d', remainder)}` : '');
        },
        disconnectModalTitle () {
            return sprintf(s__('AICatalog|Disconnect %{name}?'), {
                name: this.item.name
            });
        },
        disconnectModalMessage () {
            return s__('AICatalog|Existing agent chats will continue to reference content already retrieved from this server. However, agents will no longer be able to fetch new content or perform any actions. You can reconnect at any time.');
        }
    },
    methods: {
        handleConnect () {
            this.$emit('connect', this.item);
        },
        handleDisconnectClick () {
            this.showDisconnectModal = true;
        },
        async handleDisconnect () {
            try {
                await disconnectMcpServer(this.item);
                this.$emit('disconnected', this.item);
            } catch  {
                throw new Error(s__('AICatalog|Failed to disconnect from server. Please try again.'));
            }
        }
    }
};
